import _ from 'lodash'
import Icon from '../icon'
import { menus, markActive } from './core/menu'
import Tooltip from '../tooltip'
import Button from '../button'

export default {
  name: 'KEditorMenuItem',
  inject: ['context'],
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      active: false,
      disabled: false,
      tooltipVisible: false,
    }
  },
  computed: {
    editorView() {
      return this.context.editorView
    },
    state() {
      return this.editorView && this.editorView.state
    },
    dispatch() {
      return this.editorView && this.editorView.dispatch
    },
    stateUpdateDetector() {
      return this.context.stateUpdateDetector
    },
    menu() {
      return _.find(menus, ['value', this.value])
    },
    name() {
      return this.menu && this.menu.name
    },
    icon() {
      return this.menu && this.menu.icon
    },
    markType() {
      return this.menu && this.menu.markType
    },
    command() {
      return this.menu && this.menu.command
    },
    enable() {
      return this.menu && this.menu.enable
    },
  },
  watch: {
    stateUpdateDetector: {
      immediate: true,
      handler() {
        if (this.editorView) {
          this.checkActive()
          this.checkDisabled()
        }
      },
    },
    editorView: {
      immediate: true,
      handler(value) {
        if (value) {
          this.checkActive()
          this.checkDisabled()
        }
      },
    },
  },
  created() {
  },
  mounted() {
  },
  methods: {
    checkActive() {
      this.active = this.markType && markActive(this.state, this.markType)
    },
    checkDisabled() {
      this.disabled = _.isFunction(this.enable) ? !this.enable(this.state) : !this.enable
    },
    handleClick(e) {
      e.preventDefault()

      if (!this.editorView) {
        return
      }
      this.editorView.focus()

      if (this.command) {
        this.command(this.state, this.dispatch, this.editorView)
      }
    },
  },
  render() {
    const { icon } = this
    const style = {}

    const css = {
      'km-editor__menu-item': true,
      'km-editor__menu-item--active': this.active,
      'km-editor__menu-item--disabled': this.disabled,
    }

    const attrs = {
      disabled: this.disabled,
    }

    const props = {
      icon,
      size: 'small',
    }

    const events = {
      mousedown: this.handleClick,
    }

    const nativeEvents = {}

    const data = {
      style: style,
      class: css,
      attrs: attrs,
      props: props,
      on: events,
      nativeOn: nativeEvents,
    }

    return (
      <Tooltip
        value={this.visible}
        content={this.name}
        size="small"
        delayShow={500}
      >
        <Button
          {...data}
        >
        </Button>
        <a
          {...data}
        >
          <Icon name={this.icon}></Icon>
        </a>
      </Tooltip>
    )
  },
}
